export const it = {
  // Navigation (Italian)
  explore: 'Esplora',
  search: 'Cerca',
  create: 'Crea Post',
  messages: 'Messaggi',
  notifications: 'Notifiche',
  settings: 'Impostazioni',
  profile: 'Profilo',
  logout: 'Disconnetti',
  home: 'Home',
  
  // Authentication
  signin: 'Accedi',
  signup: 'Registrati',
  login: 'Accedi',
  register: 'Registrati',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Conferma Password',
  firstName: 'Nome',
  lastName: 'Cognome',
  forgotPassword: 'Password dimenticata?',
  alreadyHaveAccount: 'Hai già un account? Accedi',
  dontHaveAccount: 'Non hai un account? Registrati',
  
  // Posts & Content
  recent: 'Recente',
  trending: 'Tendenze',
  popular: 'Popolare',
  like: 'Mi piace',
  likes: 'Mi piace',
  comment: 'Commento',
  comments: 'Commenti',
  share: 'Condividi',
  delete: 'Elimina',
  edit: 'Modifica',
  post: 'Post',
  posts: 'Post',
  title: 'Titolo',
  content: 'Contenuto',
  tags: 'Tag',
  noBlogsFound: 'Nessun blog trovato. Prova a cercare qualcos\'altro o crea il primo!',
  
  // AI Assistant
  quickActions: 'Azioni Rapide',
  writeCaption: 'SCRIVI DIDASCALIA',
  suggestTopics: 'SUGGERISCI ARGOMENTI',
  improveContent: 'MIGLIORA CONTENUTO',
  creativeIdeas: 'IDEE CREATIVE',
  clearChat: 'CANCELLA CHAT',
  aiWritingAssistant: 'Assistente di Scrittura IA',
  poweredByGroq: 'Alimentato da GROQ AI',
  aiGreeting: 'Ciao! Sono il tuo assistente di scrittura IA. Posso aiutarti a creare contenuti coinvolgenti, scrivere didascalie, suggerire argomenti per i post e migliorare la tua scrittura. Su cosa vorresti lavorare oggi?',
  askMeToHelp: 'Chiedimi aiuto con contenuti, didascalie, argomenti o scrittura...',
  aiThinking: 'L\'IA sta pensando...',
  
  // Chat & Messages
  chat: 'Chat',
  noConversationsYet: 'Nessuna conversazione ancora',
  ideafluxChat: 'Chat IdeaFlux',
  typeMessage: 'Scrivi un messaggio...',
  sendMessage: 'Invia Messaggio',
  connectingToChat: 'Connessione alla chat...',
  
  // Notifications
  noNotificationsYet: 'Nessuna notifica ancora.',
  markAllRead: 'Segna Tutto come Letto',
  clearAll: 'Cancella Tutto',
  
  // Settings
  accountSettings: 'Impostazioni Account',
  displayName: 'Nome Visualizzato',
  emailAddress: 'Indirizzo Email',
  languagePreference: 'Preferenza Lingua',
  privacySecurity: 'Privacy e Sicurezza',
  notificationPreferences: 'Preferenze Notifiche',
  allowDirectMessages: 'Consenti Messaggi Diretti',
  letOthersMessage: 'Consenti ad altri utenti di inviarti messaggi privati',
  likesOnPosts: 'Mi piace sui post',
  commentsOnPosts: 'Commenti sui post',
  newFollowers: 'Nuovi follower',
  mentions: 'Menzioni',
  save: 'Salva',
  deleteAccount: 'Elimina Account',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'Ricevi notifiche quando qualcuno',
  likesYourPosts: 'mette mi piace ai tuoi post',
  commentsOnYourPosts: 'commenta i tuoi post',
  followsYou: 'ti segue',
  mentionsYou: 'ti menziona',
  chooseNotifications: 'Scegli quali notifiche vuoi ricevere',
  controlWhoInteracts: 'Controlla chi può interagire con te',
  manageAccountInfo: 'Gestisci le informazioni e le preferenze del tuo account',
  emailCannotBeChanged: 'L\'email non può essere cambiata per motivi di sicurezza',
  
  // Common
  loading: 'Caricamento...',
  cancel: 'Annulla',
  update: 'Aggiorna',
  submit: 'Invia',
  back: 'Indietro',
  next: 'Avanti',
  previous: 'Precedente',
  online: 'Online',
  offline: 'Offline',
  
  // Profile
  editProfile: 'MODIFICA PROFILO',
  noBioYet: 'Nessuna bio ancora.',
  followers: 'Follower',
  following: 'Seguiti',
  recentActivity: 'Attività Recente',
  noPostsYet: 'Nessun post ancora',
  shareFirstPost: 'Condividi il tuo primo post!',
  bio: 'Bio',
  dateOfBirth: 'Data di Nascita',
  follow: 'Segui',
  unfollow: 'Non seguire più',
  
  // Search
  discover: 'Scopri',
  findPeopleStories: 'Trova persone, storie e idee che ti interessano',
  searchByName: 'Cerca per nome, titolo o #tag...',
  searchResults: 'Risultati di Ricerca',
  noResultsFound: 'Nessun risultato trovato',
  peopleFound: 'Persone Trovate',
  
  // Settings - Additional keys
  enterDisplayName: 'Inserisci il tuo nome visualizzato',
  saving: 'Salvando...',
  confirmDeleteAccount: 'Sei sicuro di voler eliminare il tuo account? Questa azione non può essere annullata.',
  accountDeletedSuccessfully: 'Account eliminato con successo.',
  errorDeletingAccount: 'Errore nell\'eliminazione dell\'account. Riprova.',
  settingsSavedSuccessfully: 'Impostazioni salvate con successo!',
  failedToSaveSettings: 'Impossibile salvare le impostazioni. Riprova.',
  
  // Form component
  pleaseSignInToCreate: 'Accedi per creare un post.',
  titleRequired: 'Il titolo è richiesto per pubblicare un post.',
  contentRequired: 'Il contenuto della storia è richiesto per pubblicare un post.',
  contentTooShort: 'Il contenuto della storia deve essere lungo almeno 10 caratteri.',
  postUpdatedSuccessfully: 'Post aggiornato con successo!',
  postPublishedSuccessfully: 'Post pubblicato con successo!',
  pleaseSignInToCreateBlogs: 'Accedi per creare i tuoi blog IdeaFlux.',
  enterEngagingTitle: 'Inserisci un titolo coinvolgente...',
  story: 'Storia',
  writeYourMasterpiece: 'Scrivi il tuo capolavoro...',
  addTags: 'Aggiungi tag...',
  add: 'Aggiungi',
  publishPost: 'Pubblica Post',
  
  // Post component
  linkCopiedToClipboard: 'Link copiato negli appunti! Contatore condivisioni aggiornato.',
  youAndOthers: 'Tu e {{count}} altri',
  unknownUser: 'Utente Sconosciuto',
  noImage: 'Nessuna Immagine',
  deletePost: 'Elimina Post',
  confirmDeletePost: 'Sei sicuro di voler eliminare questo post?',
};